/* eslint-disable camelcase */
import axios from 'axios';
import {
  applicationId,
  envId,
  appResourceHubUrl,
  tenantId
} from '../settings.json';
class ConfigService {
  fetchConfig = async () => {
    const headers = {
      'content-type': 'application/json',
      'x-tenant-id': tenantId
    };

    const url = `${appResourceHubUrl}/configurations/environments/${window.REACT_APP_ENV_ID ||
      envId}/applications/${applicationId}`;

    const { data } = await axios.create()({
      method: 'get',
      url,
      headers
    });

    const applicationPartConfigurations = Object.entries(
      data.applicationPartConfigurations
    ).reduce((acc, [configId, configData]) => {
      const appName = configData.applicationPart.name;
      acc[appName] = acc[appName] || {};
      acc[appName][configId] = configData.configuration;
      return acc;
    }, {});

    const mappedConfigData = {
      global: { ...data.globalConfigurations },
      widgets: applicationPartConfigurations,
      pages: {}
    };

    return {
      ...mappedConfigData,
      fetchDate: Date.now()
    };
  };

  fetchTaggingSheet = url => {
    fetch(`${url}`, {
      method: 'GET',
      withCredentials: true,
      headers: { 'content-type': 'application/json' },
      mode: 'no-cors'
    })
      .then(response => {
        console.log('response from fetch ', response);
        return response;
      })
      .catch(e => {
        console.log(e);
      });
  };

  getWidgetConfig = async key => {
    const localConfig = localStorage.getItem(`config-${applicationId}`);
    const config = localConfig
      ? JSON.parse(localConfig)
      : await this.fetchConfig();
    const WIDGET_NAME =
      config?.widgets?.drools || config?.widgets?.['guidedselling-ai'];
    const [widgetConfig] = Object.values(WIDGET_NAME);

    return key ? widgetConfig[key] : widgetConfig;
  };
}

const inst = new ConfigService();
export default inst;
